import PropTypes from 'prop-types';
import React from 'react';

import { BadgeTypes } from '../../../../constants/Badge';
import Badge from '../../Badge/Badge';

import RowItemBadges from './RowItemBadges';

class RowItemStandardBadges extends React.PureComponent {
  static propTypes = {
    isClean: PropTypes.bool,
    isExplicit: PropTypes.bool,
    isFullRowLink: PropTypes.bool,
    isInteractive: PropTypes.bool,
    isRadioOnly: PropTypes.bool,
    isRowExtraLarge: PropTypes.bool,
    isUnavailable: PropTypes.bool,
    shouldHideBadges: PropTypes.bool,
    useDarkTheme: PropTypes.bool,
    useLightTheme: PropTypes.bool,
  };

  renderSingleBadge = badgeType => {
    return (
      <Badge
        badgeType={badgeType}
        isDark={this.props.useDarkTheme}
        isLight={this.props.useLightTheme}
        isInline={true}
      />
    );
  };

  shouldRenderBadges = () => {
    return (
      !this.props.shouldHideBadges &&
      (this.props.isRadioOnly ||
        this.props.isUnavailable ||
        this.props.isExplicit ||
        this.props.isClean)
    );
  };

  render() {
    if (!this.shouldRenderBadges()) {
      return null;
    }

    const { isInteractive, isFullRowLink } = this.props;

    return (
      <RowItemBadges isInteractive={isInteractive} isFullRowLink={isFullRowLink}>
        {this.props.isExplicit && this.renderSingleBadge(BadgeTypes.EXPLICIT_SHORT)}
        {this.props.isClean && this.renderSingleBadge(BadgeTypes.CLEAN)}
        {this.props.isRadioOnly && this.renderSingleBadge(BadgeTypes.RADIO)}
        {this.props.isUnavailable && this.renderSingleBadge(BadgeTypes.UNAVAILABLE)}
      </RowItemBadges>
    );
  }
}

export default RowItemStandardBadges;
